/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-03-15 16:13:45
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-09-23 17:49:07
 * @FilePath: \cei-saas-platform\src\api\stafflist.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import request from '@/utils/request'

// 获取员工列表
export function getUserList(data) {
	return request({
		url: '/User/getUserList',
		method: 'post',
		data
	})
}

// 编辑员工
export function editUser(data) {
	return request({
		url: '/User/editUser',
		method: 'post',
		data
	})
}

// 添加员工
export function addUser(data) {
	return request({
		url: '/User/addUser',
		method: 'post',
		data
	})
}

// 查看员工
export function checkUser(data) {
	return request({
		url: '/User/checkUser',
		method: 'post',
		data
	})
}

// 接受邀请
export function acceptInvitation(data) {
	return request({
		url: '/User/acceptInvitation',
		method: 'post',
		data
	})
}

// 拒绝邀请
export function refuseInvitation(data) {
	return request({
		url: '/User/refuseInvitation',
		method: 'post',
		data
	})
}

// 导出员工列表
export function exportUser(data) {
	return request({
		url: '/User/exportUser',
		method: 'post',
		data
	})
}

// 导出员工列表
export function getSelfData() {
	return request({
		url: '/User/getSelfData',
		method: 'post'
	})
}

// 获取渠道二维码
export function getUserQrcode(data) {
	return request({
		url: '/User/getUserQrcode',
		method: 'post',
		data
	})
}

// 绩效-添加考核人员
export function addAssessment(data) {
	return request({
		url: '/User/addAssessment',
		method: 'post',
		data
	})
}
//绩效-添加绩效标准
export function addPerformStandard(data) {
	return request({
		url: '/User/addPerformStandard',
		method: 'post',
		data
	})
}
// 绩效-添加反馈
export function addFeedback(data) {
	return request({
		url: '/User/addFeedback',
		method: 'post',
		data
	})
}

// 绩效-添加反馈-人员信息接口
export function feedbackInfo(data) {
	return request({
		url: '/User/feedbackInfo',
		method: 'post',
		data
	})
}
// 绩效-撤销接口
export function assRevoke(data) {
	return request({
		url: '/User/assRevoke',
		method: 'post',
		data
	})
}

// 绩效-删除考评人员
export function delAssessment(data) {
	return request({
		url: '/User/delAssessment',
		method: 'post',
		data
	})
}

// 绩效-获取员工列表
export function getMemberList(data) {
	return request({
		url: '/User/getMemberList',
		method: 'post',
		data
	})
}

// 绩效-获取考核人员列表
export function getAssessmentList(data) {
	return request({
		url: '/User/getAssessmentList',
		method: 'post',
		data
	})
}
// 绩效-获取考核详情主体数据
export function getAssDetail(data) {
	return request({
		url: '/User/getAssDetail',
		method: 'post',
		data
	})
}
// 绩效-获取绩效标准列表
export function getStandardList(data) {
	return request({
		url: '/User/getStandardList',
		method: 'post',
		data
	})
}

// 绩效-修改绩效标准启用状态
export function upStandardEnable(data) {
	return request({
		url: '/User/upStandardEnable',
		method: 'post',
		data
	})
}

// 绩效-修改绩效标准审核状态
export function upStandardAudit(data) {
	return request({
		url: '/User/upStandardAudit',
		method: 'post',
		data
	})
}

// 绩效-删除绩效标准
export function delStandard(data) {
	return request({
		url: '/User/delStandard',
		method: 'post',
		data
	})
}
// 绩效-更新考核项目结果值
export function updateResultData(data) {
	return request({
		url: '/User/updateResultData',
		method: 'post',
		data
	})
}
// 绩效-更新自评评分
export function updateSelfScore(data) {
	return request({
		url: '/User/updateSelfScore',
		method: 'post',
		data
	})
}

// 绩效-更新上级评分
export function updateSuperiorScore(data) {
	return request({
		url: '/User/updateSuperiorScore',
		method: 'post',
		data
	})
}

// 绩效-考核详情底部数据
export function getBottomData(data) {
	return request({
		url: '/User/getBottomData',
		method: 'post',
		data
	})
}
// 绩效-考核人员确认考核内容
export function assConfirm(data) {
	return request({
		url: '/User/assConfirm',
		method: 'post',
		data
	})
}
// 绩效-批量审批
export function approval(data) {
	return request({
		url: '/User/approval',
		method: 'post',
		data
	})
}
// 绩效-导出考核人员
export function exportAssessment(data) {
	return request({
		url: '/User/exportAssessment',
		method: 'post',
		data
	})
}
//绩效-添加年度绩效
export function addYearPer(data) {
	return request({
		url: '/User/addYearPer',
		method: 'post',
		data
	})
}
// 绩效-更新某月年度绩效
export function updateYearPer(data) {
	return request({
		url: '/User/updateYearPer',
		method: 'post',
		data
	})
}
// 绩效-删除年度绩效
export function delYearPer(data) {
	return request({
		url: '/User/delYearPer',
		method: 'post',
		data
	})
}
// 绩效-修改绩效标准
export function updateStandard(data) {
	return request({
		url: '/User/updateStandard',
		method: 'post',
		data
	})
}
// 绩效-绩效标准旧数据
export function oldStandardInfo(data) {
	return request({
		url: '/User/oldStandardInfo',
		method: 'post',
		data
	})
}
// 绩效-获取绩效首页数据
export function getAssIndex(data) {
	return request({
		url: '/User/getAssIndex',
		method: 'post',
		data
	})
}

// 绩效-获取年度绩效列表
export function getYearPerList(data) {
	return request({
		url: '/User/getYearPerList',
		method: 'post',
		data
	})
}
// 绩效-获取年度绩效列表
export function getLoginAssId(data) {
	return request({
		url: '/User/getLoginAssId',
		method: 'post',
		data
	})
}
